import { render, staticRenderFns } from "./Molho.vue?vue&type=template&id=5070dd78&"
import script from "./Molho.vue?vue&type=script&lang=js&"
export * from "./Molho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports